import { colorsPalette } from './colorsPalette';
import type { Theme } from '@mui/material/styles';

export const linkStyles = {
    root: {
        fontWeight: 600,
        textDecorationColor: 'currentcolor',
        overflowWrap: 'break-word',
    },
} as const;

export const getLinkPrimaryStyles = (theme: Theme) => ({
    root: {
        color: theme.palette.primary.main,
    },
    hover: {
        color: colorsPalette.primaryCustom.dark,
    },
});

export const getTranslatedLinkStyles = (theme: Theme) => {
    const primaryStyles = getLinkPrimaryStyles(theme);

    return {
        ...linkStyles.root,
        ...primaryStyles.root,
        '&:hover': {
            ...primaryStyles.hover,
        },
    };
};
